"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SVGIcon = void 0;
const SvgIcon_1 = __importDefault(require("@material-ui/core/SvgIcon"));
const react_1 = __importStar(require("react"));
const SVGIcon = props => {
    const { className = '', size = 24, marginRight = 0, marginLeft = 0, children, color, skipContainer, otherChildren } = props, otherProps = __rest(props, ["className", "size", "marginRight", "marginLeft", "children", "color", "skipContainer", "otherChildren"]);
    const divStyle = Object.assign({ width: size, height: size, marginRight,
        marginLeft, display: 'flex', alignItems: 'center', color: color ? color.main : undefined }, props.style);
    const divClassName = 'SVGIconRoot ' + className;
    const icon = (0, react_1.useMemo)(() => (react_1.default.createElement(SvgIcon_1.default, Object.assign({}, otherProps, { style: {
            position: 'relative',
            width: size / 24 + 'em',
            height: size / 24 + 'em',
        } }),
        react_1.default.createElement("g", null,
            children,
            otherChildren))), [children, otherChildren, otherProps, size]);
    if (skipContainer)
        return icon;
    return (react_1.default.createElement("div", { className: divClassName, style: divStyle }, icon));
};
exports.SVGIcon = SVGIcon;
exports.default = exports.SVGIcon;
